export interface AuthenticatedUser {
  uid: string;
  email: string | null;
  displayName: string | null;
  photoURL: string | null;
  role: string;
}

export type OnAuthenticatedUserChanged = (user: AuthenticatedUser | null) => void;

export enum AuthenticationStatus {
  Unknown,
  Authenticated,
  NotAuthenticated,
}

export interface Authentication {
  user: AuthenticatedUser | null;
  status: AuthenticationStatus;
}

export function userIsAdmin(user: AuthenticatedUser | null): boolean {
  return user !== null && user.role === "admin";
}

export function userIsTablet(user: AuthenticatedUser | null): boolean {
  return user !== null && user.role === "tablet";
}

// create, edit, lock and send a perfume by email: the workshop devices (signed in with the
// `tablet` role) and admins. Guests (signed out, e.g. a client's own phone) can only read.
// Same check in firestore.rules and functions/src/index.ts
export function userCanEditPerfume(user: AuthenticatedUser | null): boolean {
  return userIsAdmin(user) || userIsTablet(user);
}
